import { render, staticRenderFns } from "./ChangePasswordSettings.vue?vue&type=template&id=06dc4d07"
import script from "./ChangePasswordSettings.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports